import { usePlans } from "~/api/billing/queries";
import { useMemo } from "react";
import { ILimit, IPlan, Limits } from "~/types/billing";

export const useNextPlanForLimit = (limitType: Limits, currentPlan?: IPlan) => {
  const { data: plans } = usePlans();

  const result = useMemo(() => {
    if (!plans) {
      return { nextPlan: undefined };
    }

    const activePlans = plans
      .filter((plan) => plan.status === "AC")
      .sort((a, b) => a.cost_per_month - b.cost_per_month);

    if (activePlans.length === 0) {
      return { nextPlan: undefined };
    }

    const nextPlan = activePlans.find(
      (plan) => (plan.limits?.[limitType as keyof ILimit] ?? 0) > (currentPlan?.limits?.[limitType as keyof ILimit] ?? 0) && plan?.interval == currentPlan?.interval
    );

    return { nextPlan };
  }, [plans, limitType]);

  return result;
};